import { css } from "@emotion/react";

export const textAlignCenterStyles = css({
  textAlign: "center",
});

export const overflowAutoStyles = css({
  overflow: "auto",
});

export const loaderStyles = css({ width: "100%", height: "100%", justifyContent: "center" });

export const iconInfoCss = css({
  marginRight: "8px",
});
